import { render, staticRenderFns } from "./HandleAppUpdates.vue?vue&type=template&id=6809a181"
import script from "./HandleAppUpdates.vue?vue&type=script&lang=js"
export * from "./HandleAppUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports